<div>
  <img class="btaction-icon" src="{{ action.icon }}" />
  <div class="btaction-title font-heading-5 text-brand-green">
    {{ action.title }}
  </div>
  <div class="font-body-p2" [innerHTML]="action.description"></div>
</div>
